module.exports = __webpack_public_path__ + "img/portraits_26_V.42766f13.webp";